import React, { useState, useEffect } from "react";
import twitter from "./AddingProducts/Details/icons/twitter.png";
import linkedin from "./AddingProducts/Details/icons/linkedin.png";
import dribble from "./AddingProducts/Details/icons/Dribbble.png";
import behance from "./AddingProducts/Details/icons/behance.png";
import instagram from "./AddingProducts/Details/icons/instagram 1.png";
import { LuChevronDown } from "react-icons/lu";

// Component for editing and saving profile details
export const AuthorProfile = () => {
  const saveToLocalStorage = (data) => {
    localStorage.setItem("profileData", JSON.stringify(data));
  };

  const fetchFromLocalStorage = () => {
    const data = localStorage.getItem("profileData");
    return data ? JSON.parse(data) : {
      bio: "",
      website: "",
      occupation: "",
      isAvailableForWork: false,
      socialMedia: {
        twitter: "",
        linkedin: "",
        dribble: "",
        behance: "",
        instagram: "",
      },
    };
  };

  const [formData, setFormData] = useState(fetchFromLocalStorage());

  useEffect(() => {
    const data = fetchFromLocalStorage();
    setFormData(data);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSocialMediaChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      socialMedia: {
        ...prev.socialMedia,
        [name]: value,
      },
    }));
  };

  const handleToggle = () => {
    setFormData((prev) => ({
      ...prev,
      isAvailableForWork: !prev.isAvailableForWork,
    }));
  };

  const handleSubmit = () => {
    saveToLocalStorage(formData);
    console.log(formData);
    alert("Details saved!");
  };

  return (
    <div className="lg:px-6 pt-4">
      <h1 className="text-[28px] md:text-[32px]">Edit Profile</h1>
      <div className="md:flex md:space-x-4">
        <div className="bg-[#E9E9E9] dark:bg-[#282828] px-4 py-2 my-4 rounded-lg w-full">
          <h1 className="text-[28px]">Personal Details</h1>
          <p className="text-lg py-2 opacity-60">Manage your personal details here</p>
          <p className="pb-2">Bio</p>
          <textarea
            name="bio"
            value={formData.bio}
            onChange={handleChange}
            className="h-40 border dark:border-[#5B5B5B] py-2 px-4 rounded-lg w-full bg-white dark:bg-[#1C1C1C]"
            placeholder="text goes here"
          ></textarea>

          <div className="py-4">
            <p className="pb-2">Website / Portfolio</p>
            <input
              type="text"
              name="website"
              value={formData.website}
              onChange={handleChange}
              placeholder="e.q. https://yourwebsite.com/"
              className="w-full rounded-lg p-2 bg-white dark:bg-[#1C1C1C]"
            />
          </div>
          <div className="relative py-4">
            <p className="pb-2">What Is Your Occupation?</p>
            <select
              name="occupation"
              value={formData.occupation}
              onChange={handleChange}
              className="custom-select w-full rounded-lg p-2 dark:bg-[#1C1C1C]"
            >
              <option value="">Select from list</option>
              <option value="developer">Developer</option>
              <option value="designer">Designer</option>
              <option value="manager">Manager</option>
            </select>
            <LuChevronDown className='text-xl  absolute right-2 top-[60px]'/>
          </div>
          <div className="py-4 flex items-center justify-between">
            <p className="pb-2 text-lg">Are you available for customization work?</p>
            <div onClick={handleToggle} className={`cursor-pointer w-12 rounded-full ${formData.isAvailableForWork ? 'bg-[#46BA58]' : 'bg-[#5B5B5B]'} p-[2px] `}>
              <div className={`w-5 h-5 rounded-full bg-white dark:bg-[#1c1c1c] ${formData.isAvailableForWork ? 'translate-x-[22px]' : ''}`} />
            </div>
          </div>
        </div>

        <div className="bg-[#E9E9E9] dark:bg-[#282828] px-4 py-2 my-4 rounded-lg w-full">
          <h1 className="text-[28px]">Social Media</h1>
          <p className="text-lg py-2 opacity-60">Tell people where they can find you. Fill in only where you have an account.</p>
          <div className="pt-[24px]">
            <div className="pb-2 flex items-center space-x-2">
              <img src={twitter} alt="" />
              <p>(Twitter in the past)</p>
            </div>
            <input
              type="text"
              name="twitter"
              value={formData.socialMedia.twitter}
              onChange={handleSocialMediaChange}
              placeholder="e.q. x.com/johndoe"
              className="w-full rounded-lg p-2 dark:bg-[#1C1C1C]"
            />
          </div>
          <div className="pt-5">
            <div className="pb-2 flex items-center space-x-2">
              <img src={linkedin} alt="" />
              <p>Linkedin</p>
            </div>
            <input
              type="text"
              name="linkedin"
              value={formData.socialMedia.linkedin}
              onChange={handleSocialMediaChange}
              placeholder="e.q linkedin.com/johndoe"
              className="w-full rounded-lg p-2 dark:bg-[#1C1C1C]"
            />
          </div>
          <div className="pt-5">
            <div className="pb-2 flex items-center space-x-2">
              <img src={dribble} alt="" />
              <p>Dribble</p>
            </div>
            <input
              type="text"
              name="dribble"
              value={formData.socialMedia.dribble}
              onChange={handleSocialMediaChange}
              placeholder="e.q dribble.com/johndoe"
              className="w-full rounded-lg p-2 dark:bg-[#1C1C1C]"
            />
          </div>
          <div className="pt-5">
            <div className="pb-2 flex items-center space-x-2">
              <img src={behance} alt="" />
              <p>Behance</p>
            </div>
            <input
              type="text"
              name="behance"
              value={formData.socialMedia.behance}
              onChange={handleSocialMediaChange}
              placeholder="e.q dribble.com/johndoe"
              className="w-full rounded-lg p-2 dark:bg-[#1C1C1C]"
            />
          </div>
          <div className="py-5">
            <div className="pb-2 flex items-center space-x-2">
              <img src={instagram} alt="" />
              <p>Instagram</p>
            </div>
            <input
              type="text"
              name="instagram"
              value={formData.socialMedia.instagram}
              onChange={handleSocialMediaChange}
              placeholder="e.q dribble.com/johndoe"
              className="w-full rounded-lg p-2 dark:bg-[#1C1C1C]"
            />
          </div>
        </div>
      </div>

      <div className="py-2 md:w-fit">
        <button onClick={handleSubmit} className="bg-black text-white dark:bg-white px-5 dark:text-black w-full py-3 rounded-xl">
          Save Details
        </button>
      </div>
    </div>
  );
};
